import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector, change } from "redux-form";
import DateTime from "react-datetime";
import moment from "moment";
import "./datepicker.css";
import PropTypes from "prop-types";
import providerService from "../../services/providerService";
import FilterableSelect from "../inputs/FilterableSelect";
import LoadingScreen from "../LoadingScreen";
import { withTranslation } from "react-i18next";
import { capitalizeFirstLetter } from '../../utils/helpers';

class SecondaryCareRequestForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      providers: null,
    };
  }

  componentDidMount() {
    const { accessToken, typeId } = this.props;
    providerService.getProviders(accessToken, typeId).then((providers) => {
      this.setState({
        providers,
        isLoading: false,
      });
    });
  }

  onDateSet = (date) => {
    const { dispatch } = this.props;

    let newDate = new Date(date);

    newDate = moment(newDate).locale("en").format("YYYY-MM-DD hh:mm A");
    dispatch(change("secondaryCareRequestForm", "date_time", newDate));
  };

  render() {
    const { handleSubmit, pristine, submitting, careName, t } = this.props;
    const { isLoading, providers } = this.state;

    if (isLoading)
      return (
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100px",
            minWidth: "200px",
          }}
        >
          <LoadingScreen />
        </div>
      );

    return (
      <form
        className="form"
        onSubmit={handleSubmit}
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <span style={{ fontSize: "1.5rem" }}>
          <span className="e2e-secondary-care-service-title">
            {t(`accessSecondaryCare.preferred${capitalizeFirstLetter(careName.toLowerCase())}FieldLabel`)}
          </span>
          <Field
            name="provider_id"
            className="form-input e2e-secondary-care-service-search-field"
            component={FilterableSelect}
            props={{
              items: providers || [],
              placeholder: t("accessSecondaryCare.searchByFieldPlaceholder"),
              filterBy: ["name", "address", "state.name"],
              extraKey: "address",
            }}
          />
          <Field
            component="input"
            type="hidden"
            name="date_time"
            placeholder="Date Time"
            className="e2e-secondary-care-service-date"
            required
          />
          <DateTime
            closeOnSelect
            className="e2e-secondary-care-service-date-picker"
            inputProps={{
              required: true,
              placeholder: t("accessSecondaryCare.timeDateFieldPlaceholder"),
              readOnly: true,
            }}
            onChange={this.onDateSet}
            isValidDate={(curr) =>
              curr.dayOfYear() >= DateTime.moment().dayOfYear()
            }
            locale={this.props.i18n.language}
            dateFormat="YYYY-MM-DD"
            timeFormat="hh:mm A"
          />
        </span>
        <button
          className="form-button primary_button"
          disabled={pristine || submitting}
          style={{ marginTop: "3rem" }}
        >
          {careName.toLowerCase() === "gym"
            ? t("accessSecondaryCare.accessGymFormSubmitLabel")
            : t("accessSecondaryCare.accessCareRequestFormSubmitLabel")}
        </button>
      </form>
    );
  }
}

SecondaryCareRequestForm.propTypes = {
  careName: PropTypes.string,
  accessToken: PropTypes.string,
  typeId: PropTypes.number,
  onSubmit: PropTypes.func,
};

SecondaryCareRequestForm = reduxForm({
  form: "secondaryCareRequestForm",
})(SecondaryCareRequestForm);

const selector = formValueSelector("secondaryCareRequestForm");
SecondaryCareRequestForm = connect((state) => {
  // can select values individually
  const dateTime = selector(state, "date_time");
  return {
    dateTime,
  };
})(SecondaryCareRequestForm);

const SecondaryCareRequestFormWithTranslation = withTranslation(["benefits"])(
  SecondaryCareRequestForm
);
export default SecondaryCareRequestFormWithTranslation;
